module.exports = __webpack_public_path__ + "media/images/athletes/1887-da459630ee43a1f5e243a9bc98dcb541.png";